import React from 'react';
import { Drawer } from '@mui/material';
import '../stylesheets/stylesComponents/lateralPanel.scss';

const LateralPanel = props => {
    const { anchor = 'right', children, open, className, ...restProps } = props;
    return (
        <Drawer
            anchor={anchor}
            open={open}
            classes={{ paper: `lateral-panel__base ${className}` }}
            {...restProps}
        >
            {children}
        </Drawer>
    );
};

export default LateralPanel;
